<template>
  <v-app id="app_measurements">
    <v-overlay v-model="centerLoading" :scrim="false" class="custom_centered_overlay">
      <v-progress-circular color="#2A8200" indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-container fluid>

      <v-row>
          <v-col class="mt-0" cols="7">
            <p class="custom_page_main_title">CREATE ORGANIZATION</p>
            <p class="custom_page_main_sub_title" style="opacity: 0.6">
              Start creating your desired organization through this.
            </p>
          </v-col>
          <v-col class="px-4 mt-7" cols="5">
            <v-row class="custom_tool_bar_style">
              <v-divider :thickness="3" class="divider-vertical" vertical></v-divider>
              <v-btn class="gray-text" size="x-large" variant="text" @click="backPageRoute">
                <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        
      
        <!-- Page Title -->
        

        <v-card class="pa-5 mt-5">
          <v-row>
            <v-col cols="12">
              <p class="custom_page_component_main_title pa-3">
                SETUP ORGANIZATION DATA
              </p>
            </v-col>
          </v-row>

          <v-divider></v-divider>

          <!-- Form Section -->
          <v-row class="mt-3">
            <v-col cols="12" md="6">
              <v-text-field 
                label="Organization Name *" 
                placeholder="Type Organization name here" 
                variant="outlined"
                density="comfortable"
                v-model="organization.name"
                :rules="[v => !!v || 'Organization Name is required', v => /^[a-zA-Z\s]+$/.test(v) || 'Only letters and spaces are allowed' ]"
                >
              </v-text-field>

              <v-chip size="small">Selected Color: {{ getColorName(organization.color) }}</v-chip>
              <v-divider class="mb-2 mt-2"></v-divider>
              <v-text-field class="mt-3 custom_input_field_color" v-model="organization.color" density="comfortable"
                label="Color" variant="outlined" @click="dialog = true"></v-text-field>

              <v-dialog v-model="dialog" max-width="350px">
                <v-card id="app_authentication" rounded="md">
                  <div class="pa-4">
                    <v-card color="#F0F0F0" flat>
                      <template v-slot:prepend>
                        <v-card-title class="text-subtitle-1 font-weight-bold">SET YOUR COLOR CODE</v-card-title>
                      </template>
                      <v-spacer></v-spacer>
                      <template v-slot:append>
                        <v-btn @click="dialog = false" icon="mdi-close" size="x-small"></v-btn>
                      </template>
                    </v-card>

                    <!-- Color Code Text Field -->
                    <v-text-field v-model="organization.color" class="mt-4 custom_input_field_color" label="Color Code"
                      density="comfortable" placeholder="Type your color code here" variant="outlined"></v-text-field>

                    <!-- Mode Selector -->
                    <!-- <v-autocomplete
                        v-model="mode"
                        :items="modes"
                        class="custom_input_field_color"
                        density="comfortable"
                        variant="outlined"
                      ></v-autocomplete> -->

                    <!-- Color Picker -->
                    <v-color-picker width="318px" v-model="organization.color" v-model:mode="mode"></v-color-picker>

                    <v-divider class="mt-3"></v-divider>

                    <div class="float-end mt-4">
                      <v-btn size="large" color="blue" @click="dialog = false">ADD</v-btn>
                    </div>
                  </div>
                </v-card>
              </v-dialog>

              <!-- Organization Logo-Web Upload -->
                          <v-card flat>
              <p class="custom_page_main_sub_title mb-4" style="opacity: 0.6">
                Organization Logo-Web
              </p>
                  <div class="drop-area" @click="triggerFileInput" @drop.prevent="onDrop"
                       @dragover.prevent="onDragOver">
                    <input ref="fileInput" accept="image/*" class="hidden-file-input" multiple type="file"
                           @change="onFileChange"/>
                           
                    <div v-if="previewImages.length > 0" class="image-card-container">
                      <v-card class="image-card">
                        <v-img :src="previewImages[0]" alt="Image preview" class="image-preview"></v-img>
                        <v-btn class="remove-icon" icon size="x-small" @click.stop="removeImage(0)">
                          <v-icon color="red" size="small">mdi-delete</v-icon>
                        </v-btn>
                      </v-card>
                    </div>
                    <div v-if="previewImages.length === 0" class="placeholder-container">
                      <v-icon size="36">mdi-cloud-upload</v-icon>
                      <span>Drag your photo here OR click to <span
                          style="color:#156CF7;">Browse from device</span></span>
                    </div>
                  </div>
                
            </v-card>


              <!-- Organization Logo-Mobile -->
              <v-card flat>
                <p class="custom_page_main_sub_title mb-4 mt-4" style="opacity: 0.6">
                  Organization Logo-Mobile
                </p>

                <div class="drop-area" @click="triggerFileInputMobile" @drop.prevent="onDrop"
                       @dragover.prevent="onDragOver">
                    <input ref="fileInputMobile" accept="image/*" class="hidden-file-input" multiple type="file"
                           @change="onFileChangeMobile"/>

                    <div v-if="previewImagesMobile.length > 0" class="image-card-container">
                      <v-card class="image-card">
                        <v-img :src="previewImagesMobile[0]" alt="Image preview" class="image-preview"></v-img>
                        <v-btn class="remove-icon" icon size="x-small" @click.stop="removeImageMobile(0)">
                          <v-icon color="red" size="small">mdi-delete</v-icon>
                        </v-btn>
                      </v-card>
                    </div>
                    <div v-if="previewImagesMobile.length === 0" class="placeholder-container">
                      <v-icon size="36">mdi-cloud-upload</v-icon>
                      <span>Drag your photo here OR click to <span
                          style="color:#156CF7;">Browse from device</span></span>
                    </div>
                  </div>

              </v-card>
            </v-col>

            <!-- Setup Functionalities Section -->
            <v-col cols="6">
              <p class="custom_card_title">Setup Functionalities</p>
              <v-card class="mb-1 mt-4 custom_card_box" rounded="lg">
                <v-container>
                  <v-row v-for="(item) in permissionsItems" :key="item.id" >
                    <v-col cols="12">
                      <v-checkbox v-model="item.isOn" color="primary" hide-details class="ml-5">
                        <template v-slot:label>
                          <span :class="{
                            custom_page_main_sub_title_very_small_red:
                              item.isOn,
                            'grey-text': !item.isOn,
                            }" class="font-weight-medium text-body-2 ml-3">
                              {{ item.premission_dashboard }}
                            </span>
                        </template>
                      </v-checkbox>
                      <v-divider></v-divider>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-card>

        <v-card-actions class="float-end">
          <v-btn size="x-large" class="custom_btn_primary pl-5 pr-5" @click="createNewOrganization">CREATE NEW ORGANIZATION</v-btn>
          <v-btn size="x-large" class="custom_btn_secondary" @click="backPageRoute">Cancel</v-btn>
        </v-card-actions>
      

       <!-- Snackbar to show notifications -->
       <v-snackbar v-model="snackAlert.snackbar" :color="snackAlert.snackColor" :right="snackAlert.snackBarRight"
                  :top="snackAlert.snackBarTop" timeout="3000">
        {{ snackAlert.snackMessage }}
      </v-snackbar>

    </v-container>
  </v-app>
</template>

<script>

import ntc from 'ntc';
import axios from 'axios';

export default {
  data() {
    return {
      permissionsItems: [],
      organization: {
        name: '',
        color: '#0000FF',
        webLogo: null,  
        mobileLogo: null,
      },

      form: {
      color: "", // Ensure color has a default value
    },
    dialog: false, // Ensure dialog has a default value
    centerLoading: false,
      previewImages: [],
      previewImagesMobile:[],
      primaryColor: "",
      colorOptions: ["Red", "Blue", "Green", "Yellow"],
      snackAlert: {
        snackbar: false, // Snackbar visibility
        snackColor: "", // Snackbar color
        snackMessage: "", // Snackbar message
        snackBarRight: false, // Snackbar position right
        snackBarTop: true,  // Snackbar position top
      },
     
    };
    
  },

  mounted() {
    this.getDashboardPermissions();
  },
  methods: {
    backPageRoute() {
      this.$router.go(-1);
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    triggerFileInputMobile(){
      this.$refs.fileInputMobile.click();
    },

    onFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.handleFiles(file);
      }
      event.target.value = '';
    },
    onFileChangeMobile(event) {
      const file = event.target.files[0];
      if (file) {
        this.handleFilesMobile(file);
      }
      event.target.value = '';
    },
    removeImage(index) {
      if (index >= 0 && index < this.organization.webLogo.length) {
        this.organization.webLogo.splice(index, 1);
        this.previewImages.splice(index, 1);
      }
    },

    removeImageMobile(index) {
      if (index >= 0 && index < this.organization.mobileLogo.length) {
        this.organization.mobileLogo.splice(index, 1);
        this.previewImagesMobile.splice(index, 1);
      }
    },

    handleFiles(file) {
      const validImageTypes = ['image/jpeg', 'image/png', 'image/gif'];

      if (!validImageTypes.includes(file.type)) {
        alert('Only image files are allowed!');
        return;
      }

      // Clear previous image
      this.organization.webLogo = [];
      this.previewImages = [];

      this.organization.webLogo.push(file);
      this.previewImages.push(URL.createObjectURL(file));
    },

    handleFilesMobile(file) {
      const validImageTypes = ['image/jpeg', 'image/png', 'image/gif'];

      if (!validImageTypes.includes(file.type)) {
        alert('Only image files are allowed!');
        return;
      }

      // Clear previous image
      this.organization.mobileLogo = [];
      this.previewImagesMobile = [];

      this.organization.mobileLogo.push(file);
      this.previewImagesMobile.push(URL.createObjectURL(file));
    },

    onDrop(event) {
      const files = event.dataTransfer.files;
      if (files.length > 0) this.onFileChange({ target: { files } });
    },
    onDragOver(event) {
      event.preventDefault();
    },
    getColorName(hex) {
      const color = ntc.name(hex);
      // this.convertColor = color[1];
      return color[1];
    },

    showSnackbar(message, color) {
      this.snackAlert.snackbar = true;
      this.snackAlert.snackMessage = message;
      this.snackAlert.snackColor = color;
    },


    validateForm() {
      // Validate Organization Name
      if (!this.organization.name || !/^[a-zA-Z\s]+$/.test(this.organization.name)) {
        this.showSnackbar('Organization Name is required and should contain only letters and spaces.', 'error');
        return false;
      }

      // Validate Organization Logo - Web
      if (!this.organization.webLogo || this.organization.webLogo.length === 0) {
        this.showSnackbar('Web Logo is required.', 'error');
        return false;
      }

      // Validate Organization Logo - Mobile
      if (!this.organization.mobileLogo || this.organization.mobileLogo.length === 0) {
        this.showSnackbar('Mobile Logo is required.', 'error');
        return false;
      }

      // Validate Dashboard Permissions - At least one must be selected
      const selectedPermissions = this.permissionsItems.filter(item => item.isOn);
      if (selectedPermissions.length === 0) {
        this.showSnackbar('At least one dashboard permission must be selected.', 'error');
        return false;
      }

      return true; // All validations passed
    },


    async createNewOrganization(){

      try {

        if (!this.validateForm()) {
          console.log("Form validation failed. Fix the errors and try again.");
          return;
        }

        this.centerLoading = true;
        const userId = localStorage.getItem('userId');
        const token = localStorage.getItem("token");

        const formData = new FormData();
        formData.append("userId", userId);
        formData.append("organization_name", this.organization.name);

        console.log("OrganizationNmae",this.organization.name);

        // const color = "#25656";
        formData.append("organization_color", this.organization.color);

        console.log("color",this.organization.color);

        if (this.organization.webLogo) {
          await this.convertToBase64(this.organization.webLogo[0]).then(base64String => {
            formData.append("organization_logo_web", base64String);
            console.log("webLogo",base64String);
          });
        }
       

        if (this.organization.mobileLogo) {
          await this.convertToBase64(this.organization.mobileLogo[0]).then(base64String => {
            formData.append("organization_logo_mobile", base64String);
            console.log("mobileLogo",base64String);
          });
        }

        const selectedDashboardPermissions = this.permissionsItems
        .filter(item => item.isOn)  // Keep only items where isOn is true
        .map(item => ({
            dashboardId: item.id,
            dashboardName: item.premission_dashboard,
        }));

        console.log("dashboard",selectedDashboardPermissions);
        formData.append("dashboard", JSON.stringify(selectedDashboardPermissions));

        // Step 3: API call to backend
        const response = await axios.post("/api/createOganization", formData, {
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });

        if (response.status === 201) {
          this.showSnackbar("ORGANIZATION WAS CREATED SUCCESSFULLY!", "success");
          this.clearOrganization();
          this.resetDashboardPermissions();
          this.centerLoading = false;
        } else {
          this.showSnackbar("Unexpected response status.", "warning");
          this.centerLoading = false;
        }
        
      } catch (error) {
        console.log(error);
        this.centerLoading = false;
      }

    },

    clearOrganization(){

      this.organization.name = null;
      this.organization.color = '#0000FF';
      this.organization.webLogo = null;
      this.organization.mobileLogo = null;
      this.previewImages = [];
      this.previewImagesMobile = [];
      
    },

    resetDashboardPermissions() {
      this.permissionsItems.forEach(item => {
        item.isOn = false;
      });
    },

     // Method to convert a file to a base64 string
     convertToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const result = reader.result;
          // Remove the "data:image/png;base64," part
          const base64String = result.split(',')[1];
          resolve(base64String);
        };
        reader.onerror = error => reject(error);
      });
    },


    // Get Dashboard
    getDashboardPermissions() {
      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem('token');

      axios.post(`/api/getDashboard?userId=${userId}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the Authorization header with the Bearer token
            }
          })
          .then(response => {
            const dashboards = response.data.data;
            this.permissionsItems = dashboards.map(dashboard => ({
              id: dashboard.id,
              premission_dashboard: dashboard.premission_dashboard,
              isOn: false,
            }));
            console.log('Dashboard permissions:', this.permissionsItems);
          })
          .catch(error => {
            console.error('Error fetching dashboard permissions:', error);
          });
    },

  },
};
</script>

<style scoped>
.drop-area {
  padding: 20px;
  margin-top: 0px;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  cursor: pointer;
  background-color: #f0f0f0;
  border: 2px dashed #ccc;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 8px;
  padding-top: 13px;
  height: 216px;
}

.image-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.image-card {
  position: relative;
  width: 100px;
  height: 100px;
}

.remove-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  background: white;
  border-radius: 50%;
}

.hidden-file-input {
      display: none;
    }
</style>
